import { useField } from 'formik';
import React, { ComponentType, PropsWithChildren, ReactNode } from 'react';
import clsx from 'clsx';
import { FieldErrorMessage } from 'ui-components';

import useStyles from './FormElementWrapper.style';

export interface FormElementWrapperProps {
  className?: string;
  error: boolean;
  errorMessage?: string | null;
  errorMessageAddon?: string | ReactNode;
  classNameError?: string;
  classNameErrorWrapper?: string;
  uniqueId?: string;
}

const FormElementWrapper: React.FC<FormElementWrapperProps> = ({
  children,
  error,
  errorMessage,
  errorMessageAddon,
  className,
  classNameError,
  classNameErrorWrapper,
  uniqueId,
}) => {
  const c = useStyles({});
  return (
    <div className={clsx(c.root, className, error && c.error, error && classNameErrorWrapper)}>
      {children}
      {error && (errorMessage || errorMessageAddon) &&
        <FieldErrorMessage className={classNameError} id={uniqueId}>
          <p>{errorMessage} {errorMessageAddon}</p>
        </FieldErrorMessage>
      }
    </div>
  );
};

export default FormElementWrapper;

export const withFormElementErrorWrapper = <P,>(Component: ComponentType<P>, displayErrorMessage = true, shouldCheckTouched = true) =>
  (props: PropsWithChildren<P> & { name: string, classNameError?: string, classNameErrorWrapper?: string, classNameWrapper?: string; uniqueId?: string })=> {
  const [, meta] = useField(props.name);
  const fieldError = meta.error;
  const hasError = (meta.touched || !shouldCheckTouched) && (fieldError !== undefined);
  const { classNameError, classNameErrorWrapper, classNameWrapper, uniqueId, ...restProps } = props as any;
  return (
      <FormElementWrapper
          classNameError={props.classNameError}
          classNameErrorWrapper={props.classNameErrorWrapper}
          className={props.classNameWrapper}
          error={hasError}
          errorMessage={hasError && displayErrorMessage ? fieldError : null}
          uniqueId={uniqueId}>
        <Component {...restProps} hasError={hasError}>
          {props.children}
        </Component>
      </FormElementWrapper>);
};
